/*
 * @Author: wangshengqiang
 * @Date: 2022-02-24 16:06:42
 * @LastEditTime: 2022-03-20 15:01:45
 * @LastEditors: wangshengqiang
 * @Description:
 */
import Renderer from './components/Render';
import App from './components/App';
import Gs from './Gs';
import request from './utils/request'; // export * from './baseComponents/index.js';

export * from './utils';
export * from './services';
export * from './hooks';
export * from './store/index';
export { default as Trial } from './components/Trial';
export { default as Form } from './components/Form';
export { fetchClick as fetchNextStep } from '@/components/Button';
export { Renderer, App, request };
export default Gs;